import Hero from "../../components/Hero/Hero";

function ContactPage() {
  return <Hero title={"Contact Us"} />;
}
export default ContactPage;
